import {Controller} from '@hotwired/stimulus'

// Connects to data-controller="partnerships"
export default class extends Controller {

  static targets = [
    'emailLoginSection',
    'initialSection',
    'emailInput',
    'emailError',
    'emailInputContainer',
    'emailLoginForm',
  ];

  static values = {
    emailRequiredError: String
  }

  showEmailLogin() {
    this.initialSectionTarget.classList.add('d-none');
    this.emailLoginSectionTarget.classList.remove('d-none');
  }

  onEmailInput() {
    this.resetErrorState();
  }

  resetErrorState() {
    this.emailErrorTarget.innerText = '';
    this.emailInputContainerTarget.classList.remove('has-error');
  }

  onEmailFormSubmit(event) {
    const email = this.emailInputTarget.value;
    if (!email) {
      event.preventDefault();
      this.emailErrorTarget.innerText = this.emailRequiredErrorValue;
      this.emailInputContainerTarget.classList.add('has-error');
    }
  }
}
